<div
  class="sidebar"
  [class.small]="isSidebarFolded()"
>
  <button
    mat-mini-fab
    color="primary"
    class="sidebar-arrow"
    (click)="toggleSidebar()"
  >
    <i
      class="arrow-icon"
      [class.left]="!isSidebarFolded()"
    ></i>
  </button>
  <ng-content/>
  <app-info-application
    class="app-info"
    [needChangelogModal]="true"
  />
</div>
